<template>
  <div>
    <div class="col-lg-12" style="" v-if="workoutPlan" :class="{ loading: isLoading }">

      <!-- <div class="btn-group mb-2">
        <button type="button" class="btn btn-default btn-lg dropdown-toggle ml-0 pl-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Workout Program: {{ workoutPlan.workout_program.name }}
        </button>
        <div class="dropdown-menu dropdown-menu-right">
          <button
            v-for="workoutProgram in availableWorkoutPrograms"
            v-bind:key="workoutProgram.id"
            :disabled="workoutPlan.workout_program_id == workoutProgram.id || workoutPlanIsApproved"
            class="dropdown-item"
            type="button"
            @click="changeWorkoutProgram(workoutProgram)"
          >{{workoutProgram.name}} <span v-if="workoutPlan.coaching_program_id == workoutProgram.id">(selected)</span>
          </button>
        </div>
      </div> -->

      <!-- <div class="mb-2">
        <h5>
          Workout Program: {{ workoutPlan.workout_program.name }}
          <button class="btn btn-sm btn-link" @click="openChangeProgramModal"><i class="mdi mdi-18px mdi-pencil" /></button>
        </h5>
      </div>
      -->
      <div class="d-flex flex-row mb-2" style="">
        <div class="flex-col mr-auto">
          <h5>
            <!-- Workout Program:  -->
            {{ workoutPlan.workout_program.name }}<template v-if="workoutPlan.workout_program_block">: {{ workoutPlan.workout_program_block.name }}</template>
            <span v-if="workoutPlan.is_modified" class="small muted"> (modified on {{ workoutPlan.updated_at | moment("M/DD/YYYY hh:mm a")}})</span>
            <button class="btn btn-sm btn-link" @click="openChangeProgramModal"><i class="mdi mdi-18px mdi-pencil" /></button>
          </h5>
        </div>

        <div class="flex-col" v-if="!workoutPlanIsFilesetType">
          <div class="btn-group">
            <button type="button" class="btn btn-default" @click="openSaveWorkoutProgramModal">
              <i class="mdi mdi-content-save" /> Save
            </button>
            <!-- <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="mdi mdi-content-save" /> Save
            </button>
            <div class="dropdown-menu dropdown-menu-right">
              <button class="dropdown-item" type="button" @click="openSaveWorkoutProgramModal">Save as new program</button>
              <button class="dropdown-item" type="button" @click="openSaveWorkoutProgramModal">Save as new block</button>
              <button class="dropdown-item" type="button" @click="openSaveWorkoutProgramModal">Update current block</button>
            </div> -->
          </div>
        </div>
      </div>

      <div class="alert alert-info" v-if="workoutPlanIsApproved">
        This workout plan was approved by {{ workoutPlan.approved_by.first_name }} {{ workoutPlan.approved_by.last_name }} on {{ workoutPlan.approved_at | moment("M/DD/YYYY hh:mm a")}}
      </div>

      <div v-if="workoutPlanIsFilesetType">
        <WorkoutPlanPanelFileset :initial-workout-plan="workoutPlan" @workout-plan-updated="workoutPlanUpdated"></WorkoutPlanPanelFileset>
      </div>
      <div v-else>
        <WorkoutPlanPanelBuilder :initial-workout-plan="workoutPlan" @workout-plan-updated="workoutPlanUpdated"></WorkoutPlanPanelBuilder>
      </div>
      <!-- <div class="container-fluid horizontal-scrollable">
        <div class="row flex-row flex-nowrap">
          <div class="col-4 my-3" v-bind:key="day.id" v-for="day in selectedDays">
            <WorkoutPlanPanelDay :initial-day="day" @day-updated="weekUpdated" />
          </div>
        </div>
      </div> -->
    </div>
    <modal v-if="showChangeWorkoutProgramModal" @close="showChangeWorkoutProgramModal=false">
      <h3 slot="header">Change workout program</h3>
      <div slot="body">
        <div class="alert alert-danger">Changing the workout program will overwrite the current plan. All work will be lost.</div>
        <div class="form-row align-items-center mb-2">
          <div class="col-3">
            <label for="program-to-add-programs">Program</label>
          </div>
          <div class="col">
            <div class="form-group">
              <select class="form-control" v-model="selectedWorkoutProgramId">
                <option disabled value="">Please select one</option>
                <option
                  v-for="workoutProgram in availableWorkoutPrograms"
                  v-bind:key="workoutProgram.id"
                  :value="workoutProgram.id"
                  >{{workoutProgram.name }}
                  <span>({{ workoutProgram.type }})</span>
                  <span v-if="workoutPlan.workout_program_id == workoutProgram.id">(current)</span>
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="form-row align-items-center mb-2" v-if="selectedWorkoutProgramType=='builder'">
          <div class="col-3">
            <label for="program-to-add-programs">Block</label>
          </div>
          <div class="col">
            <div class="form-group">
              <select class="form-control" v-model="selectedWorkoutProgramBlockId">
                <option disabled value="">Please select one</option>
                <option
                  v-for="block in selectedWorkoutProgramBlocks"
                  v-bind:key="block.id"
                  :value="block.id"
                  >{{block.name }} <span v-if="workoutPlan.workout_program_block_id == block.id">(current)</span> </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button class="btn btn-default" @click="showChangeWorkoutProgramModal = false">Cancel</button>
        <button class="btn btn-primary" :disabled="!changeWorkoutProgramModalFormIsValid" @click="changeWorkoutProgram">Change Program</button>
      </div>
    </modal>

    <modal v-if="showSaveWorkoutProgramModal && !workoutPlanIsFilesetType" @close="showSaveWorkoutProgramModal=false">
      <h3 slot="header">Save as new workout program</h3>
      <div slot="body">

        <div class="form-row align-items-center mb-2">
          <div class="col-3">
            <label for="program-to-add-programs">Program</label>
          </div>
          <div class="col">
            <div class="form-group">
              <select class="form-control" v-model="newWorkoutProgram.id">
                <option value="">- Create New Program - </option>
                <option
                  v-for="workoutProgram in availableWorkoutPrograms"
                  v-bind:key="workoutProgram.id"
                  :value="workoutProgram.id"
                  >{{workoutProgram.name }} <span v-if="workoutPlan.workout_program_id == workoutProgram.id">(current)</span> </option>
              </select>
            </div>
          </div>
        </div>
        <div v-if="!newWorkoutProgram.id" class="p-3 bg-light border rounded">
          <div class="form-row align-items-center mb-2">
            <div class="col-3">
              <label for="program-to-add-name">Name</label>
            </div>
            <div class="col">
              <input
                class="form-control"
                placeholder="e.g. Bodyweight Beginner Program"
                id="program-to-add-name"
                required
                v-model="newWorkoutProgram.name"
              />
            </div>
          </div>
          <div class="form-row align-items-center mb-2">
            <div class="col-3">
              <label for="program-to-add-description">Description</label>
            </div>
            <div class="col">
              <textarea
                class="form-control"
                placeholder="e.g. Calisthenics program for beginners"
                id="program-to-add-description"
                required
                v-model="newWorkoutProgram.description"
              />
            </div>
          </div>
          <div class="form-row align-items-center mb-2">
            <div class="col-3">
              <label for="program-to-add-programs">Programs</label>
            </div>
            <div class="col">
              <div class="form-group">
                <div class="form-check" v-for="(program, index) in availablePrograms" v-bind:key="index">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'program-'+program.id"
                    v-model="newWorkoutProgram.program_ids"
                    :value="program.id">
                  <label
                    class="form-check-label"
                    :for="'program-'+program.id"
                  >
                    {{ program.name }} <span v-if="isCurrentProgram(program.id)">(current)</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="form-row align-items-center mb-2">
          <div class="col-3">
            <label for="program-to-add-programs">Block</label>
          </div>
          <div class="col">
            <div class="form-group">
              <select class="form-control" v-model="selectedWorkoutProgramBlockId">
                <option value="">- Create New Block - </option>
                <option
                  v-for="block in selectedWorkoutProgramBlocks"
                  v-bind:key="block.id"
                  :value="block.id"
                  >{{block.name }} <span v-if="workoutPlan.workout_program_block_id == block.id">(current)</span> </option>
              </select>
            </div>
          </div>
        </div> -->
        <div class="p-3 bg-light border rounded">
          <div class="form-row align-items-center mb-2">
            <div class="col-3">
              <label for="program-to-add-block-name">Block Name</label>
            </div>
            <div class="col">
              <input
                class="form-control"
                placeholder="e.g. Month 1"
                id="program-to-add-block-name"
                required
                v-model="newWorkoutProgram.block_name"
              />
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button class="btn btn-default" @click="showSaveWorkoutProgramModal = false">Cancel</button>
        <button v-if="newWorkoutProgram.id" @click="doSaveNewWorkoutProgramBlock" class="btn btn-primary">Save New Program Block</button>
        <button v-else @click="doSaveNewWorkoutProgram" class="btn btn-primary">Save New Program</button>
      </div>
    </modal>
  </div>
</template>
<script>
  import WorkoutPlanPanelFileset from '@coach/js/components/WorkoutPlanPanelFileset.vue'
  import WorkoutPlanPanelBuilder from '@coach/js/components/WorkoutPlanPanelBuilder.vue'
  import draggable from 'vuedraggable'
  import store from "@coach/js/store/store";
  import { mapGetters } from "vuex";

  export default {
    props: [
      'initialWorkoutPlan'
    ],
    store: store,
    components: {
      WorkoutPlanPanelFileset,
      WorkoutPlanPanelBuilder,
    },
    data() {
      return {
        // workoutPlan: this.initialWorkoutPlan,
        isLoading: false,
        showChangeWorkoutProgramModal: false,
        selectedWorkoutProgramId: this.initialWorkoutPlan.workout_program_id,
        selectedWorkoutProgramBlockId: this.initialWorkoutPlan.workout_program_block_id,
        showSaveWorkoutProgramModal: false,
        newWorkoutProgram: {
          id: this.initialWorkoutPlan.workout_program_id,
          name: null,
          description: null,
          program_ids: [this.$root.plan.program_id],
          block_name: null,
        },
      }
    },
    mounted() {
      // Not sure I like this. But it saves us from doing an unnecessary call on load.
      this.$store.dispatch("plan/setWorkoutPlan", this.initialWorkoutPlan);
    },
    computed: {
      ...mapGetters("plan", {
        workoutPlan: 'workoutPlan'
      }),
      // workoutPlan: function() {
      //   return this.$store.getters['plan/workoutPlan'];
      // },
      availableWorkoutPrograms: function() {
        return this.$root.availableWorkoutPrograms;
      },
      availablePrograms: function() {
        return this.$root.availablePrograms;
      },
      changeWorkoutProgramModalFormIsValid: function() {
        return this.selectedWorkoutProgramId != null &&
          (
            (this.selectedWorkoutProgramType=='builder' && this.selectedWorkoutProgramBlockId != null)
            || this.selectedWorkoutProgramType!='builder'
          );
      },
      workoutPlanIsFilesetType: function() {
        return this.workoutPlan.workout_program.type == 'fileset';
      },
      workoutPlanIsBuilderType: function() {
        return this.workoutPlan.workout_program.type == 'builder';
      },
      workoutPlanIsApproved: function() {
        return this.workoutPlan.approved_at != null;
      },
      availableWorkoutPrograms: function() {
        return this.$root.availableWorkoutPrograms;
      },
      // canApproveWorkoutPlan: function() {
      //   return this.selectedWorkoutFileSet != null && !this.workoutPlanIsApproved;
      // },
      // numWeeks: function() {
      //   return this.workoutPlan.weeks.length;
      // }
      selectedWorkoutProgram: function() {
        let workoutProgram = this.getAvailableWorkoutProgramById(this.selectedWorkoutProgramId)
        if (workoutProgram) {
          return workoutProgram;
        }
        return null;
      },
      selectedWorkoutProgramType: function() {
        let workoutProgram = this.selectedWorkoutProgram;
        return workoutProgram ? workoutProgram.type: null;
      },
      selectedWorkoutProgramBlocks: function() {
        let workoutProgram = this.selectedWorkoutProgram;
        return workoutProgram ? workoutProgram.blocks: [];
      }
    },
    methods: {
      isCurrentProgram: function(program_id) {
        return program_id == this.$root.plan.program_id;
      },
      getAvailableWorkoutProgramById: function(id) {
        return this.availableWorkoutPrograms ?
          this.availableWorkoutPrograms.find(program => program.id == id)
          : null;
      },
      // setSelectedWorkoutProgram: function() {
      //   this.selectedWorkoutProgram = this.getAvailableWorkoutProgramById(this.workoutPlan.workout_program_id);
      // },
      openChangeProgramModal: function() {
        this.selectedWorkoutProgramId = this.workoutPlan.workout_program_id;
        this.showChangeWorkoutProgramModal = true;
      },
      closeChangeProgramModal: function() {
        this.showChangeWorkoutProgramModal = false;
      },
      changeWorkoutProgram: function(workoutProgram) {
        var _this = this;
        _this.isLoading = true;
        axios.put('/api/workout_plans/' + _this.workoutPlan.id, {
          'workout_program_id': _this.selectedWorkoutProgramId,
          'workout_program_block_id': _this.selectedWorkoutProgramType == 'builder' ? _this.selectedWorkoutProgramBlockId : null
        }).then(function (response) {
          // _this.selectedWorkoutProgramId = response.data.data.workout_program_id;
          // _this.workoutPlan = response.data.data;
          // _this.selectedWorkoutFileSet = _this.workoutPlan.workout_file_set;
          _this.workoutPlanUpdated();
          _this.closeChangeProgramModal();
          _this.isLoading = false;
        });
      },
      openSaveWorkoutProgramModal: function(){
        this.showSaveWorkoutProgramModal = true;
      },
      closeSaveWorkoutProgramModal: function(){
        this.showSaveWorkoutProgramModal = false;
      },
      doSaveNewWorkoutProgram: function() {
        var _this = this;
        axios
          .post("/api/workout_programs", {
            source_workout_plan_id: this.workoutPlan.id,
            name: this.newWorkoutProgram.name,
            description: this.newWorkoutProgram.description,
            program_ids: this.newWorkoutProgram.program_ids,
            block_name: this.newWorkoutProgram.block_name,
          })
          .then(response => {
            _this.$root.getAllWorkoutPrograms(); // refresh workout programs
            // _this.workoutPlan.weeks.push(response.data.data)
            _this.$toasted.success("Workout Program Saved!!")
            // _this.$emit('workout-plan-updated', _this.workoutPlan);
            _this.workoutPlanUpdated();
            _this.closeSaveWorkoutProgramModal();
          })
          .catch(e => {
            _this.$toasted.error(e.response.data.message);
          });
      },
      doSaveNewWorkoutProgramBlock: function() {
        var _this = this;
        axios
          .post("/api/workout_program_blocks", {
            source_workout_plan_id: this.workoutPlan.id,
            workout_program_id: this.newWorkoutProgram.id,
            name: this.newWorkoutProgram.block_name,
          })
          .then(response => {
            _this.$root.getAllWorkoutPrograms(); // refresh workout programs
            // _this.workoutPlan.weeks.push(response.data.data)
            _this.$toasted.success("Workout Program Block Saved!!")
            // _this.$emit('workout-plan-updated', _this.workoutPlan);
            _this.workoutPlanUpdated();
            _this.closeSaveWorkoutProgramModal();
          })
          .catch(e => {
            _this.$toasted.error(e.response.data.message);
          });
      },
      workoutPlanUpdated: function() {
        var _this = this;
        // _this.isLoading = true;
        // axios.get('/api/workout_plans/' + _this.workoutPlan.id).then(function (response) {
        //   _this.workoutPlan = response.data.data;
        //   _this.isLoading = false;
        // });
        this.$store.dispatch("plan/getWorkoutPlan", this.initialWorkoutPlan.id).then(() => {
          // _this.workoutPlan = _this.$store.getters['plan/workoutPlan'];
          // console.log("Woohoo!!! WorkoutPlan fetched");
          // console.log(this.$store.getters['plan/workoutPlan']);
          // console.log(this.workoutPlan);
          _this.$emit('workoutplan-updated', _this.workoutPlan);
        });
      },
    },
    // watch: {
      // initialWorkoutPlan: function (newVal,oldVal) {
      //   Vue.set(this, 'workoutPlan', newVal);
      //   // Vue.set(this, 'selectedWorkoutFileSet', this.initialWorkoutPlan.workout_file_set);
      // }
    // }
}
</script>
